/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    interface ITypeAheadListItem {
        model: string,
        selected: any
    }

    class TypeAheadListController implements angular.IComponentController {
        static $inject = [];

        public items: any[];
        public selected: string | number;
        public template: string;
        public list: ITypeAheadListItem[];

        private compileTemplate: HandlebarsTemplateDelegate;

        public $onInit() {
            this.list = [];
            if (this.items && this.items.length) {
                this.items.forEach((item) => this.list.push({ model: item.id, selected: item }))
            }

            if (this.template) {
                this.setTemplateConfig();
            }
        }

        public getContents(template): string {
            return this.compileTemplate(template);
        }

        public modelChanged(item: ITypeAheadListItem): void {
            if (item.model) {
                item.selected = item.model;
            }
            this.setItems()
        }

        public deleteRow(index: number): void {
            this.list.splice(index, 1);
            this.setItems()
        }

        public addRow(): void {
            this.list.push({ model: '', selected: null })
        }

        private setItems(): void {
            this.items = this.list
                .filter((item: ITypeAheadListItem) => !!item.selected)
                .map((item: ITypeAheadListItem) => item.selected);
        }

        private setTemplateConfig(): void {
            let defaultTemplate = '{{displayName}}';
            switch (this.template.toLowerCase()) {
                case 'manufacturer':
                    this.compileTemplate = Handlebars.compile(defaultTemplate);
                    break;
                case 'productcategory':
                    this.compileTemplate = Handlebars.compile(defaultTemplate);
                    break;
                case "servicecategory":
                    this.compileTemplate = Handlebars.compile(defaultTemplate);
                default:
                    this.compileTemplate = Handlebars.compile(defaultTemplate);
            }
        }
    }

    const typeAheadList: angular.IComponentOptions = {
        templateUrl: 'app/components/controls/typeAheadList/typeAheadList.template.html',
        bindings: {
            template: '@?',
            items: '=',
            contentKey: '@',
            addContentKey: '@',
            tabIndex: '@',
            name: '@',
            disabled: '=ngDisabled',
            itemTemplateUrl: '@?',
            typeAheadCriteria: '=?',
            asLocationId: '=?',
            businessTypeId: '=?',
        },
        controller: TypeAheadListController
    };

    angular.module('meevo.components.controls')
        .component('meevoTypeAheadList', typeAheadList);
}